import { ActionMapHandler, Message, RS } from "@utils/types";

function hasPayload<A>(msg: any): msg is { payload: any } {
  return (msg as { payload: any }).payload !== undefined;
}

export function makeReducer<S, A extends RS>(handlers: ActionMapHandler<A, S>) {
  return (state: S, action: Message<A>) => {
    const payload = hasPayload(action) ? action.payload : (null as any);
    const handler = handlers[action.type];

    return handler({ state, action: action.type, payload });
  };
}
